module.exports = __webpack_public_path__ + "img/holidaySettings.1f2c60c0.svg";